export default String.raw`
{% if settings.compareProducts == 'yes' -%}
    {% assign maxProductsInComparison = config.Products.ProductComparer -%}

    <dialog class="dialog comparison__dialog">
        <div class="dialog__header limit">
            <div class="dialog__header-info">
                <h2 class="dialog__header-title">{{translations.CantAddMoreToComparer}}</h2>
            </div>
            <form method="dialog">
                <button class="dialog__close close-js" aria-label="{{ translations.Close }}">
                    <svg aria-hidden="true" height="24" width="24">
                        <use href="css/img/fontawesome-icons.svg?v={{lqTS}}#times-{{settings.iconStyle}}"></use>
                    </svg>
                </button>
            </form>
        </div>
        <div class="dialog__content limit">
            <p>{{translations.MaxProductsInComparer | Format: maxProductsInComparison}}</p>
        </div>
        <div class="dialog__actions">
            <form method="dialog">
                <button class="pure-button close-js" style="gap: 10px;">
                    <svg height="14" width="9">
                        <use href="css/img/fontawesome-icons.svg?v={{lqTS}}#chevron-left-{{settings.iconStyle}}"></use>
                    </svg>
                    <span>{{translations.BackToShopping}}</span>
                </button>
            </form>
            <a class="primary-action-button" href="{{ page.BaseHref }}{{config.DefinedPages.ProductComparisonTool.Url}}">
                <span>{{translations.GoToComparer}}</span>
                <svg height="24" width="24">
                    <use href="css/img/fontawesome-icons.svg?v={{lqTS}}#balance-scale-left-{{settings.iconStyle}}"></use>
                </svg>
            </a>
        </div>
    </dialog>
{% endif -%}

`